import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) { }

  async canActivate() {
    const isLogin = localStorage.getItem("profile");
    if (isLogin) {
      this.router.navigateByUrl('/menu/home');
    }
    else {
      return true;
    }
  }
}
